<template>
    <div class="content" style="height: 99%;">
        <el-progress v-if="progressShow" :show-text="false" :stroke-width="6" color="#919191"
                     :percentage="progress"></el-progress>
        <pdf
                v-for="i in numPages"
                :key="i"
                :page="i"
                :src="pdfSrc" style="width: 100%; margin: auto; height: auto;" @num-pages="pageCount=$event">
        </pdf>
    </div>
</template>

<script>
    import pdf from 'vue-pdf'
    import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
    export default {
        name: "Agreement",
        components: {
            pdf
        },
        data() {
            return {
                pdfSrc: '',
                numPages: 0,
                progress: 0,
                progressShow: true
            }
        },
        created() {
            const param = {type: 0, pageSize: 1, pageNum: 1, isEnable: 1};
            this.$axios.get('/api/protocol/selectprotocolbyparam', {params: param}).then(response => {
                const data = response.data.resultData.rows;
                let url = '';
                data.forEach(item => {
                    if (item.lang === 2) {
                        url = item.file
                    }
                });
                this.pdfSrc = pdf.createLoadingTask({url: '/api' + url, CMapReaderFactory});
                this.pdfSrc.onProgress = progress => {
                    let tempProgress = progress.loaded / progress.total * 100;
                    if(tempProgress > 100){
                        tempProgress = 100;
                    }
                    this.progress = tempProgress;
                    if (this.progress === 100) {
                        setTimeout(() => {
                            this.progressShow = false;
                            for(const key in require.cache) {
                                if(require && require.cache && require.cache[key] && require.cache[key].exports && require.cache[key].exports.default instanceof Uint8Array){
                                    console.log(key);
                                    delete require.cache[key];
                                }
                            }
                        }, 500);
                    }
                };
                this.loadPdfHandler();
            }).catch(e => {
                console.log(e);
                this.$toast(this.$t('common.message.operateFail'))
            });
        },
        methods: {
            loadPdfHandler() {
                this.pdfSrc.promise.then(pdf => {
                    this.numPages = pdf.numPages;
                });
            }
        }
    }
</script>

<style scoped>
    .content{
        width: 98%;
        height: 100%;
        margin: 0 auto;
        background-color: #fff;
        font-size: 14px;
    }
</style>
